import { render, staticRenderFns } from "./SummaryBrandTrade.vue?vue&type=template&id=2ccf26c0"
import script from "./SummaryBrandTrade.vue?vue&type=script&lang=js"
export * from "./SummaryBrandTrade.vue?vue&type=script&lang=js"
import style0 from "./SummaryBrandTrade.vue?vue&type=style&index=0&id=2ccf26c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports